import { ref } from "vue";

export const DATE_TIME_RANGE_HINTS = "now, now-N(s|min|h), YYYY-MM-DD hh:mm";

export function useDateTimeRangeValidation() {
  const isValid = ref(false);

  const validateDateTimeString = (v) => {
    const regex = /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}$/;
    isValid.value = regex.test(v);
    return isValid.value;
  };

  const validateTimeExpression = (expression) => {
    if (!expression) {
      isValid.value = false;
      return false;
    }

    if (typeof expression !== "string") {
      isValid.value = false;
      return false;
    }

    const expr = expression.toLowerCase();
    
    if (expr === "now") {
      isValid.value = true;
      return true;
    }
    
    if (!expr.startsWith("now")) {
      isValid.value = false;
      return false;
    }

    if (expr.length <= 3) {
      isValid.value = false;
      return false;
    }
    
    const operator = expr.charAt(3);
    if (operator !== "+" && operator !== "-") {
      isValid.value = false;
      return false;
    }
    
    // Extract the value and unit with regex
    const valueUnitRegex = /^now[+-](\d+)(s|min|h)$/;
    const match = expr.match(valueUnitRegex);

    isValid.value = Boolean(match);

    return isValid.value;
  };

  const expressionToDate = (expression) => {
    if (typeof expression !== "string") return expression;

    if (!validateTimeExpression(expression)) {
      return new Date(expression); // Try to parse as regular date string
    }
    
    const expr = expression.toLowerCase();
    
    if (expr === "now") {
      return new Date();
    }
    
    const operator = expr.charAt(3);
    const valueUnitMatch = expr.substring(4).match(/^(\d+)(s|min|h)$/);
    
    if (valueUnitMatch) {
      const value = parseInt(valueUnitMatch[1], 10);
      const unit = valueUnitMatch[2];
      const now = new Date();
      
      let ms = 0;
      if (unit === "s") ms = value * 1000;
      else if (unit === "min") ms = value * 60 * 1000;
      else if (unit === "h") ms = value * 60 * 60 * 1000;
      
      return new Date(now.getTime() + (operator === "+" ? ms : -ms));
    }
    
    return new Date(expression);
  };

  return {
    validateTimeExpression,
    validateDateTimeString,
    expressionToDate,
    isValid,
  };
}

